import React from 'react';
import { useTranslation } from 'react-i18next';
import MessageModal from '@wix/da-ds/pkg/modals/dsPresets/MessageModal';
import { Warning } from '@wix/da-ds/pkg/Icons/Confirmations/Warning';
import { ConfirmButton } from '@wix/da-ds/pkg/modals/dsPresets/MessageModal/buttons';

interface Props {
  onRequestClose: () => void;
}

const BoostNotSupportedModal: React.FC<Props> = ({ onRequestClose }) => {
  const { t } = useTranslation();

  return (
    <MessageModal
      isOpen
      variant="vertical"
      image={<Warning />}
      onRequestClose={onRequestClose}
      title={t('boostDeviation.notSupportedModal.title')}
      message={t('boostDeviation.notSupportedModal.message')}
      footerButtons={[
        <ConfirmButton key="confirm" onClick={onRequestClose}>
          {t('common.gotIt')}
        </ConfirmButton>,
      ]}
    />
  );
};
BoostNotSupportedModal.displayName = 'BoostNotSupportedModal';

export default BoostNotSupportedModal;
